import { Box, styled } from "@mui/material";

import { SettingsContent } from "components/window/core/settings/components";
import { SidePanelProps } from "contexts/sidePanels";

const PanelContent = styled(Box)`
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: auto;
`;

/**
 * Settings panel - SidePanel variant of the Settings window
 */
export function SettingsPanel(_props: SidePanelProps) {
    return (
        <PanelContent>
            <SettingsContent useSlideInPicker />
        </PanelContent>
    );
}
